<script setup>
import { computed } from 'vue'
import ActionButton from '../src/index.vue'
import { extActionButtonProps } from '../src/props'

const props = defineProps({
  ...extActionButtonProps,
  extension: {
    type: Object,
    required: true
  }
})

const items = computed(() => {
  const values = []
  const subscript = props.extension.options.subscript
  const superscript = props.extension.options.superscript

  if (subscript !== false) values.push('subscript')
  if (superscript !== false) values.push('superscript')

  return values
})

const commands = {
  subscript: 'toggleSubscript',
  superscript: 'toggleSuperscript'
}

function action(item) {
  const c = props.editor.chain().focus()
  if (item === 'subscript') c.unsetSuperscript().toggleSubscript().run()
  if (item === 'superscript') c.unsetSubscript().toggleSuperscript().run()
}
</script>

<template>
  <ActionButton
    v-for="item in items"
    :key="item"
    :editor="editor"
    :action="() => action(item)"
    :is-active="() => editor.isActive(item) || false"
    :disabled="!editor.can()[commands[item]]()"
    :tooltip="t(`editor.${item}.tooltip`)"
    :icon="item"
  />
</template>